import { Tabs } from "devextreme-react";
import React, { useState } from "react";
import ConfigureMappingData from "../../../common/ConfigureMappingData";

export default function Configuration() {
  const [configType, setConfigType] = useState("projectStatus");
  const [dataSource, setDataSource] = useState([
    {
      text: "Project Status",
      type: "projectStatus",
    },
    {
      text: "Task Category",
      type: "taskCategory",
    },
  ]);

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.text}
      </div>
    );
  };

  const onItemClick = (e) => {
    setConfigType(e.itemData.type);
  };

  return (
    <React.Fragment>
      <Tabs
        dataSource={dataSource}
        defaultSelectedIndex={0}
        height={40}
        itemRender={itemRender}
        onItemClick={onItemClick}
        // width={450}
        width={"auto"}
      />
      {configType == "projectStatus" && (
        <div>
          <div style={{ margin: "16px 0px" }}></div>
          <ConfigureMappingData
            cat={"13"}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "Project Status",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name={"Project Status"}
            sortOrderEnabled={true}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
        </div>
      )}
      {configType == "taskCategory" && (
        <div>
          <div style={{ margin: "16px 0px" }}></div>
          <ConfigureMappingData
            cat={"13"}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "Task Category",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name={"Task Category"}
            sortOrderEnabled={true}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
        </div>
      )}
    </React.Fragment>
  );
}
